import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
// import layout from './views/layout-dashboard1.vue'
//import HelloWorld from '@/components/HelloWorld'
import envConfig from './common/env';

Vue.use(Router)
const router = new Router({
    mode: 'history',
    base: '',
    routes: [{
            'path': '/auth',
            'component': require('./views/layout-auth.vue'),
            'children': [
                // ==================== 登录 ====================
                {
                    'path': 'login',
                    'component': require('./views/auth/login.vue'),
                },

            ],
        },
        {
            'path': '/helpCenter',
            'component': require('./views/help/helpCenter.vue'),
        },
        {
            'path': '/changePassword',
            'component': require('./views/auth/changePassword.vue'),
        },
        {
            path: '/',
            redirect: '/auth/login',
            component: () =>
                import ('./views/layout-dashboard.vue'),
            children: [{
                    path: '/msg-data',
                    component: () =>
                        import ('./views/report-data/msg-data.vue'),
                    meta: {
                        crumbList: ['数据报表', '短信数据']
                    },
                },
                {
                    path: '/loss-data',
                    component: () =>
                        import ('./views/report-data/loss-data.vue'),
                    meta: {
                        crumbList: ['数据报表', '防丢失助手数据']
                    },
                },
                {
                  path: '/outreach-data',
                  component: () =>
                      import ('./views/report-data/outreach-data.vue'),
                  meta: {
                      crumbList: ['数据报表', '外拓数据统计']
                  },
                },
                {
                  path: '/group-outreach-data',
                  component: () =>
                      import ('./views/report-data/group-outreach-data.vue'),
                  meta: {
                      crumbList: ['数据报表', '集团外拓数据统计']
                  },
                },
                {
                    path: '/home',
                    component: () =>
                        import ('./views/auth/home.vue'),
                    meta: {
                        crumbList: ['首页']
                    },
                },
                {
                    path: '/business-wx-user',
                    component: () =>
                        import ('./views/system-manage/business-user-list/business-user-list.vue'),
                    meta: {
                        crumbList: ['B端公众号用户']
                    },
                },
                {
                    // ==================== 系统管理-- ====================
                    path: '/system-manage',
                    component: () =>
                        import ('./views/system-manage/layout.vue'),
                    children: [{
                            path: 'users-list',
                            component: () =>
                                import ('./views/system-manage/users-list/users-list.vue'),
                            meta: {
                                crumbList: ['系统管理', '用户管理']
                            },
                        },
                        {
                          path: 'group-users-list',
                          component: () =>
                              import ('./views/system-manage/group-users-list/users-list.vue'),
                          meta: {
                              crumbList: ['系统管理', '集团用户管理']
                          },
                        },
                        {
                          path: 'company-users-list',
                          component: () =>
                              import ('./views/system-manage/users-list/company-users-list.vue'),
                          meta: {
                              crumbList: ['系统管理', '公司用户管理']
                          },
                        },
                        {
                          // ====================活动审核===========================
                          path: 'activity-check-list',
                          component: () =>
                              import ('./views/system-manage/activity-check/activity-check-list.vue'),
                          meta: {
                              crumbList: ['系统管理', '集团活动审核'],
                              menuActive: '/system-manage/activity-check-list'
                          },
                        },
                        {
                          // ====================代步车审核===========================
                          path: 'scooter-check-list',
                          component: () =>
                              import ('./views/system-manage/scooter-check/scooter-check-list.vue'),
                          meta: {
                              crumbList: ['系统管理', '集团代步车审核'],
                              menuActive: '/system-manage/scooter-check-list'
                            },
                        },
                        {
                            path: 'rainers-list',
                            component: () =>
                                import ('./views/system-manage/rainers-list/rainers-list.vue'),
                            meta: {
                                crumbList: ['系统管理', '及时雨管理']
                            },
                        },
                        {
                            path: 'group-rainers-list',
                            component: () =>
                                import ('./views/system-manage/group-rainers-list/rainers-list.vue'),
                            meta: {
                                crumbList: ['系统管理', '集团及时雨']
                            },
                        },
                        {
                          path: 'rainers-check',
                          component: () =>
                              import ('./views/system-manage/rainers-check/rainers-check-list.vue'),
                          meta: {
                              crumbList: ['系统管理', '及时雨审核']
                            },
                        },
                        {
                          path: 'brand-list',
                          component: () =>
                              import ('./views/system-manage/brand-list/brand-list.vue'),
                          meta: {
                              crumbList: ['系统管理', '品牌管理']
                          },
                        },
                        {
                            path: 'business-user-list',
                            component: () =>
                                import ('./views/system-manage/business-user-list/business-user-list.vue'),
                            meta: {
                                crumbList: ['系统管理', 'b端公众号用户']
                            },
                        },
                        {
                            path: 'roles-list',
                            component: () =>
                                import ('./views/system-manage/roles-list/roles-list.vue'),
                            meta: {
                                crumbList: ['系统管理', '角色管理']
                            },
                        },
                        {
                            path: 'insurance-list',
                            component: () =>
                                import ('./views/system-manage/insurance-list/insurance-list.vue'),
                            meta: {
                                crumbList: ['企业管理', '保险管理']
                            },
                        },
                        {
                            path: 'resource-list',
                            component: () =>
                                import ('./views/system-manage/resource-list/resource-list.vue'),
                            meta: {
                                crumbList: ['系统管理', '资源配置']
                            },
                        },
                        {
                            path: 'demo-appointment-list',
                            component: () =>
                                import ('./views/system-manage/demo-appointment/demo-appointment-list.vue'),
                            meta: {
                                crumbList: ['系统管理', '预约演示']
                            },
                        },
                        {
                            path: 'to-business',
                            component: () =>
                                import ('./views/system-manage/toBusiness.vue'),
                            meta: {
                                // crumbList: ['系统管理','用户管理']
                            },
                        },
                    ]
                },
                // ====================维修单管理===========================
                {
                    // ====================集团维修单列表===========================
                    path: '/loss-assessment/list',
                    component: () =>
                        import ('./views/loss-assessment-manage/loss-assessment-manage-list.vue'),
                    meta: {
                        crumbList: ['维修单管理', '集团维修单列表'],
                        menuActive: '/loss-assessment-manage/list'
                    },
                },
                {
                    // ====================集团消/撤单审核列表===========================
                    path: '/cancel-refuse-check/list',
                    component: () =>
                        import ('./views/cancel-refuse-check/cancel-refuse-check.vue'),
                    meta: {
                        crumbList: ['维修单管理', '集团消/未进店审核列表'],
                        menuActive: '/cancel-refuse-check/list'
                    },
                },  
                {
                    // ====================维修单详情===========================
                    path: '/loss-assessment-manage/detail/:orderId/:fromType',
                    component: () =>
                        import ('./views/loss-assessment-manage/loss-assessment-manage-detail.vue'),
                    meta: {
                        crumbList: ['维修单管理', '集团维修单列表', '信息详情'],
                        menuActive: '/loss-assessment-manage/list'
                    },
                },
                // ==================== 渠道信息列表====================
                {
                  path: '/channel',
                  component: () => import('./views/channeThree/layout.vue'),
                  children: [
                    {
                      path: 'list',
                      component: () => import('./views/channeThree/newChannelList2'),
                      meta: {
                        crumbList: ['集团渠道信息', '集团渠道信息列表']
                      },
                    },
                    {
                      // ==================== 渠道信息详情 ====================
                      path: 'detail',
                      component: () => import('./views/channeThree/newChannel'),
                      meta: {
                        crumbList: ['集团渠道信息', '集团渠道信息列表', '集团渠道信息详情'],
                      },
                    },
                  ]
                },
                // ====================视频管理===========================
                {
                  path: '/video',
                  component: () =>
                      import ('./views/video/layout.vue'),
                  children: [{
                          path: 'list',
                          component: () =>
                              import ('./views/video/list.vue'),
                          meta: {
                              crumbList: ['信息管理', '集团视频订单'],
                              menuActive: '/video/list'
                          },
                      },
                      {
                          path: 'detail/:orderId',
                          component: () =>
                              import ('./views/video/detail.vue'),
                          meta: {
                              crumbList: ['信息管理', '集团视频订单', '集团视频订单详情'],
                              menuActive: '/video/list'
                          },
                      }
                  ]
              },
                // ====================客户视频资讯===========================
                {
                  path: '/consultation',
                  component: () =>
                      import ('./views/consultation/layout.vue'),
                  children: [{
                          path: 'list',
                          component: () =>
                              import ('./views/consultation/list.vue'),
                          meta: {
                              crumbList: ['信息管理', '集团客户咨询'],
                          },
                      },
                      {
                          path: 'detail/:orderId',
                          component: () =>
                              import ('./views/consultation/detail.vue'),
                          meta: {
                              crumbList: ['信息管理', '集团客户咨询', '客户咨询详情'],
                          },
                      }
                  ]
                },
                {
                    // ==================== 小程序管理-- ====================
                    path: '/wx-manage',
                    component: () =>
                        import ('./views/wx-manage/layout.vue'),
                    children: [{
                            path: 'activity-manage',
                            component: () =>
                                import ('./views/wx-manage/activity-manage/activity-list.vue'),
                            meta: {
                                crumbList: ['小程序管理', '活动管理']
                            },
                        },
                        {
                            path: 'content-manage',
                            component: () =>
                                import ('./views/wx-manage/content-manage/content-list.vue'),
                            meta: {
                                crumbList: ['小程序管理', '内容管理']
                            },
                        }
                    ]
                },
                //===========================储值管理=========================
                {
                    path: '/recharge-manage',
                    component: () =>
                        import ('./views/wx-manage/layout.vue'),
                    children: [{
                            //====================储值列表===========================
                            path: 'recharge/recharge',
                            component: () =>
                                import ( /* webpackChunkName: "rapid-manage" */ './views/recharge-manage/recharge/recharge'),
                            meta: {
                                crumbList: ['储值管理', '储值列表'],
                            },
                        },
                        {
                            path: 'charge/video',
                            component: () =>
                                import ( /* webpackChunkName: "rapid-manage" */ './views/recharge-manage/charge-video/charge'),
                            meta: {
                                crumbList: ['储值管理', 'VFS视频-扣款记录'],
                            },
                        },
                        {
                            //====================储值列表===========================
                            path: 'charge/charge',
                            component: () =>
                                import ( /* webpackChunkName: "rapid-manage" */ './views/recharge-manage/charge/charge'),
                            meta: {
                                crumbList: ['储值管理', '信息费-扣款记录'],
                            },
                        },
                        {
                            //====================储值列表===========================
                            path: 'charge/charge-system',
                            component: () =>
                                import ( /* webpackChunkName: "rapid-manage" */ './views/recharge-manage/charge-system/charge'),
                            meta: {
                                crumbList: ['储值管理', '系统费-扣款记录'],
                            },
                        },
                        {
                            //====================储值列表===========================
                            path: 'recharge/statisticsCompany',
                            component: () =>
                                import ( /* webpackChunkName: "rapid-manage" */ './views/recharge-manage/statisticsCompany/statisticsCompany'),
                            meta: {
                                crumbList: ['储值管理', '公司余额'],
                            },
                        },
                    ]
                },
                //===========================短信管理=========================
                {
                    path: '/message-manage',
                    component: () =>
                        import ('./views/message-match/layout.vue'),
                    children: [{
                            //====================信息匹配===========================
                            path: 'match',
                            component: () =>
                                import ('./views/message-match/match.vue'),
                            meta: {
                                crumbList: ['短信管理', '信息匹配'],
                            },
                        },
                        {
                            //====================信息匹配===========================
                            path: 'filter',
                            component: () =>
                                import ('./views/message-match/filterWords.vue'),
                            meta: {
                                crumbList: ['短信管理', '过滤词管理'],
                            },
                        },
                        {
                            //====================防止丢失===========================
                            path: 'prevent-loss',
                            component: () =>
                                import ('./views/message-match/prevent-loss.vue'),
                            meta: {
                                crumbList: ['短信管理', '防丢失管理'],
                            },
                        },
                    ]
                },
                {
                    path: '/ai-manage',
                    component: () => import ('./views/ai-manage/layout.vue'),
                    children: [
                        {
                            path: 'noticeTemplate/list',
                            component: () => import ('./views/ai-manage/noticeTemplate/list.vue'),
                            meta: {
                                crumbList: ['AI管理', '通知模版管理'],
                            }
                        },
                        {
                            path: 'noticeConfig/list',
                            component: () => import ('./views/ai-manage/noticeConfig/list.vue'),
                            meta: {
                                crumbList: ['AI管理', '通知配置管理'],
                            }
                        },
                        {
                            path: 'wechatRobot/list',
                            component: () => import ('./views/ai-manage/wechatRobot/list.vue'),
                            meta: {
                                crumbList: ['AI管理', '微信客服管理'],
                            }
                        },
                        {
                            path: 'intelligentAssistant/list',
                            component: () => import ('./views/ai-manage/intelligentAssistant/list.vue'),
                            meta: {
                                crumbList: ['AI管理', '知识库管理'],
                            }
                        },
                        {
                            path: 'intelligentAssistant/training/:id',
                            component: () => import ('./views/ai-manage/intelligentAssistant/training.vue'),
                            meta: {
                                crumbList: ['AI管理', '知识库管理', '训练'],
                            }
                        },
                        {
                            path: 'sqlbot-aide',
                            component: () => import ('./views/ai-manage/sqlbot-chat/aide.vue'),
                            meta: {
                                crumbList: ['AI管理', '智能助手'],
                            }
                        },
                        {
                            path: 'sqlbot-chat',
                            component: () => import ('./views/ai-manage/sqlbot-chat/index.vue'),
                            meta: {
                                crumbList: ['AI管理', '智能助手管理'],
                            }
                        },
                        {
                            path: 'knowledgeBaseNew',
                            component: () => import ('./views/ai-manage/knowledgeBaseNew.vue'),
                            meta: {
                                crumbList: ['AI管理', '智能问答管理'],
                            }
                        },
                    ]
                },
                // ==================== 目标智导相关内容 ====================
                {
                    path: '/targetDs',
                    component: () => import ('./views/targetDs/layout.vue'),
                    children: [
                        {
                            path: 'configView',
                            component: () => import ('./views/targetDs/configView/list.vue'),
                            meta: {
                                crumbList: ['目标智导', '配置管理'],
                            },
                        },
                        {
                            path: 'screenView',
                            component: () => import ('./views/targetDs/screenView/list.vue'),
                            meta: {
                                crumbList: ['目标智导', '进店大屏'],
                            },
                        },
                        {
                            path: 'reportView',
                            component: () => import ('./views/targetDs/reportView/list.vue'),
                            meta: {
                                crumbList: ['目标智导', '考核报表'],
                            },
                        },
                        {
                            path: 'appointmentView',
                            component: () => import ('./views/targetDs/appointmentView/list.vue'),
                            meta: {
                                crumbList: ['目标智导', '预约管理'],
                            },
                        },
                    ]
                },
            ],
            meta: {
                auth: true
            },
        },

    ]
})

router.beforeEach((to, from, next) => {
    console.log(to.fullPath)
        // console.log(envConfig.businessUrl);
        //  var tokenLocal=localstorage;
    var url = to.fullPath;
    var urlArray = url.split('/');

    console.log(urlArray)
    const token = Cookies.get('token');
    console.log('token')
    console.log(token)
    if (urlArray.indexOf('account') > -1) {
        /*if(to.matched.some(m => m.meta.auth)) {
          if(token) {
            if(to.fullPath=='/system-manage/to-business'){
              window.location.href=envConfig.businessUrl+token;
            }else{
              next()
            }
          } else {
            next({
              path: '/account/auth/login',
              query: {
                returnUrl: to.fullPath
              }
            })
          }
        } else {
          next()
        }*/
    } else if (urlArray.indexOf('bussi') > -1) {
        window.location.href = url + '?token=' + token
    } else if (urlArray.indexOf('general') > -1) {
        window.location.href = url
    } else if (urlArray.indexOf('4s') > -1) {
        window.location.href = url
    } else {
        if (to.matched.some(m => m.meta.auth)) {
            if (token) {
                if (to.fullPath == '/system-manage/to-business') {
                    window.location.href = envConfig.businessUrl + token;
                } else {
                    next()
                }
            } else {
                console.log('位置')
                console.log(to)
                next({
                    path: '/auth/login',
                    query: {
                        returnUrl: to.fullPath
                    }
                })
            }
        } else {
            next()
        }
    }
});
export default router


// WEBPACK FOOTER //
// ./src/router.js